class SiteModal extends window.BAO.CustomElement({
  SuperClass: HTMLDialogElement,
}) {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)
    this.handleClose = this.handleClose.bind(this)

    if (this.externalEls?.trigger?.exists) {
      this.externalEls.trigger.elements.forEach((triggerEl) => {
        this.listeners.add(triggerEl, 'click', this.handleTrigger)
      })
    }

    if (this.els?.close?.exists) {
      this.els.close.elements.forEach((closeEl) => {
        this.listeners.add(closeEl, 'click', this.handleClose)
      })
    }

    this.listeners.add(this, 'cancel', (e) => {
      e.preventDefault()
      this.handleClose()
    })
  }

  handleTrigger (event) {
    if (event.currentTarget.dataset.id !== this.dataset.id) return

    this.removeAttribute('inert')
    this.showModal()
    document.body.classList.add('util-SiteOverflowed')
    window.BAO.dispatchEvent(window.BAO.EVENTS.MODAL.OPEN, {
      id: this.dataset.id,
    })
  }

  handleClose () {
    this.close()
    this.setAttribute('inert', '')
    document.body.classList.remove('util-SiteOverflowed')

    window.BAO.dispatchEvent(window.BAO.EVENTS.MODAL.CLOSED, {
      id: this.dataset.id,
    })
  }
}

if (!customElements.get('site-modal')) {
  customElements.define('site-modal', SiteModal, { extends: 'dialog' })
}
